import { render, staticRenderFns } from "./AccountSettingsScreen.vue?vue&type=template&id=6247856a&"
import script from "./AccountSettingsScreen.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsScreen.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingsScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports